import axios from 'axios';
import store from '../store';
import i18n from '../lang';
import router from '../router';

const service = axios.create({
    baseURL: '',
    withCredentials: true,
    headers: {'Content-Type': 'application/json'}
});

//service.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
//service.defaults.headers['Content-Type'] = 'application/json';

service.interceptors.request.use(
    (config) => {
      if(config.mask){
        store.dispatch('loading/setLoading', true);
      }
      // do something before request is sent
      if (!config.baseDomain) {
        console.error('请设置请求的参数baseDomain为url的根域名');
      } else {
        config.baseURL = config.baseDomain;
      }
  
      if (store.getters.token) {
        const token = store.state.settings.token;
        config.headers[token.token_name] = `${token.token_prefix || ''}${store.getters.token}${token.token_suffix || ''}`;
      }
  
      // 签名参数
      if (config.method.toLowerCase() === 'get') {
        // get请求
        // 将url参数合并到config.params
        const url = new URL(config.url, config.baseURL);
        config.params = config.params || {};
        const searchParams = new URLSearchParams(url.search);
        // if (searchParams.keys().length > 0) {
        for (const [key, value] of searchParams) {
          config.params[key] = value;
        }
        config.url = config.url.split('?')[0];
        // }
      }
      const easyToken= localStorage.getItem('easyToken');
      config.headers["Authorization"]='Bearer '+easyToken;
      return config;
    },
    (error) => {
      console.log(error);
      store.dispatch('loading/setLoading', false);
      return Promise.reject(error);
    }
  );
  
  // response interceptor
  service.interceptors.response.use(
    (response) => {
      store.dispatch('loading/setLoading', false);
      if (!(response.data instanceof Blob) && responseHandleFun && typeof responseHandleFun === 'function') {
        const flag = responseHandleFun(response, i18n, router, store);
        if (flag) {
          return response.data;
        } else {
          return Promise.reject(new Error(response.statusText || 'Error'));
        }
      } else {
        return response.data;
      }
    },
    (error) => {
      if(error.response.data.errMessage){
        alert(error.response.data.errMessage);
      }
      store.dispatch('loading/setLoading', false);
      if (responseHandleFun && typeof responseHandleFun === 'function') {
        responseHandleFun(error.response, i18n, router, store);
      }
      localStorage.removeItem('easyToken');
      location.reload();
      return Promise.reject(error);
    }
  );
  let responseHandleFun = null;
  
  function responseHandle(fun) {
    if (fun && typeof fun === 'function') {
      responseHandleFun = fun;
    }
  }
  
  service['responseHandle'] = responseHandle;
  export default service;